import { Job } from "../models/job";
import { Measurement } from "../models/measurement";
import { handleGetConvertValue } from "./converts";

export const calculateAndConvertOrdersVolume = (measurement: Measurement, jobs: Job[]) => {
  if (jobs.length) {
    let itemsVolume: number = 0;
    const itemsJob = jobs.map((shipment) => shipment.itemsJob);

    if (itemsJob) {
      for (const itemJob of itemsJob) {
        const items = itemJob?.filter((item) => item.subStatus === "Actual");

        if (items?.length) {
          const volume = itemJob?.reduce(
            (prev, curr) => (prev += Number(curr.volume || 0) * Number(curr.quantity || 1)),
            0
          );

          if (volume && !Number.isNaN(volume)) itemsVolume += volume;
        }
      }

      return handleGetConvertValue(itemsVolume, measurement?.code, measurement?.decimalPlaces);
    }
  }

  return 0;
};
